export enum CreateOrderStepsEnum {
  CUSTOMER_SELECTION,
  ROUTE_SELECTION,
  PRODUCT_MANAGEMENT,
  DRIVER_SELECTION,
}

export default CreateOrderStepsEnum;
